import type { SVGProps } from 'react'

export function Chevron(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.94032 7.43934C4.5261 6.85355 5.47585 6.85355 6.06164 7.43934L12.001 13.3787L17.9403 7.43934C18.5261 6.85355 19.4758 6.85355 20.0616 7.43934C20.6474 8.02512 20.6474 8.97487 20.0616 9.56066L13.0616 16.5607C12.4759 17.1464 11.5261 17.1464 10.9403 16.5607L3.94032 9.56066C3.35453 8.97487 3.35453 8.02513 3.94032 7.43934Z'
        fill='currentColor'
      />
    </svg>
  )
}
